export const SEARCH_PARAMS_KEYS = {
  PLOT_ID: 'plot-id',
  SUPPLIER_ID: 'supplier-id',
  FILTERS_PANEL: 'filters-panel',
  EXPANDED: 'expanded',
  PLOTS: 'plots',
  IMPORT_MODAL: 'import-modal',
  RISK_MODAL: 'risk-modal',
  SEARCH: 'search',
  FILTERS_PRECISION: 'filters-precision',
  FILTERS_RISK: 'filters-risk',
  FILTERS_COMMODITIES: 'filters-commodities',
  FILTERS_COUNTRY: 'filters-country',
  FILTERS_SUPPLIER: 'filters-supplier',
  FILTERS_ACTIVITY: 'filters-activity',
  FILTERS_STATUS: 'filters-status',
  FILTERS_PRODUCT: 'filters-product',
  FILTERS_SURFACE_AREA: 'filters-surface-area',
  FILTERS_UPDATED_AT: 'filters-updated-at',
  USER_PANEL: 'user-panel',
} as const;
